export enum AgreementContentBlockType {
  TITLE = 'title',
  PARAGRAPH = 'paragraph',
}

export enum AgreementType {
  COOKIE_POLICY = 'cookiePolicy',
  TERMS_OF_USE = 'termsOfUse',
  PRIVACY_POLICY = 'privacyPolicy',
}

export interface IAgreementAcceptancePayload {
  agreementTypes: AgreementType[];
}

export interface IAgreementAcceptanceRequestBody {
  agreementTypes: AgreementType[];
}

export interface IAgreementAcceptanceResponse {
  agreementTypes: AgreementType[];
}

export interface IAgreementContentBlock {
  type: `${AgreementContentBlockType}`;
  value: string;
}
